/* KINNIKU TIMES 記事コメント。
   My FITPEAK（Supabase Auth）のアカウントでログインした人だけが投稿できる。
   投稿は承認制で、承認されるまでは本人にだけ「承認待ち」として見える。 */
(function () {
  var SB = 'https://fajqnrqfjugonbssssts.supabase.co';
  var KEY = 'sb_publishable_Yzy7ryBHN4YTKCGqJkio6A_wYv2cq-n';
  var SKEY = 'fp_myfp_session';
  var NKEY = 'fp_kt_name';
  var MYFP = 'https://my.fitpeak.co/my-fitpeak';

  var root = document.querySelector('[data-kt-comments]');
  if (!root) return;
  var path = (root.getAttribute('data-path') || location.pathname).split('?')[0].replace(/\/$/, '');
  var elForm = root.querySelector('[data-kt-cm-form]');
  var elList = root.querySelector('[data-kt-cm-list]');
  var elCount = root.querySelector('[data-kt-cm-count]');

  function ls(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ls2(k, v) { try { v === null ? localStorage.removeItem(k) : localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* noop */ } }

  var session = ls(SKEY);

  function authPost(p, body) {
    return fetch(SB + '/auth/v1/' + p, {
      method: 'POST',
      headers: { apikey: KEY, 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); });
  }

  function saveSession(d) {
    if (!d || !d.access_token) return null;
    session = {
      access_token: d.access_token,
      refresh_token: d.refresh_token,
      expires_at: Math.floor(Date.now() / 1000) + (d.expires_in || 3600) - 60,
      email: d.user && d.user.email
    };
    ls2(SKEY, session);
    return session;
  }

  function clearSession() { session = null; ls2(SKEY, null); }

  function token() {
    if (!session) return Promise.resolve(null);
    if (session.expires_at > Math.floor(Date.now() / 1000)) return Promise.resolve(session.access_token);
    return authPost('token?grant_type=refresh_token', { refresh_token: session.refresh_token })
      .then(function (r) {
        if (r.ok && r.data && r.data.access_token) { saveSession(r.data); return session.access_token; }
        clearSession(); return null;
      })
      .catch(function () { return null; });
  }

  function rpc(fn, body, needAuth) {
    return token().then(function (t) {
      if (needAuth && !t) return { error: 'login_required' };
      return fetch(SB + '/rest/v1/rpc/' + fn, {
        method: 'POST',
        headers: { apikey: KEY, Authorization: 'Bearer ' + (t || KEY), 'Content-Type': 'application/json' },
        body: JSON.stringify(body || {})
      }).then(function (r) { return r.ok ? r.json() : null; });
    });
  }

  function when(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    var m = Math.floor((Date.now() - d.getTime()) / 60000);
    if (m < 1) return 'たった今';
    if (m < 60) return m + '分前';
    if (m < 1440) return Math.floor(m / 60) + '時間前';
    var j = new Date(d.getTime() + 9 * 3600000);
    return j.getUTCFullYear() + '年' + (j.getUTCMonth() + 1) + '月' + j.getUTCDate() + '日';
  }

  function msg(box, text, kind) {
    var p = box.querySelector('.kt-cm__msg');
    if (!p) { p = document.createElement('p'); p.className = 'kt-cm__msg'; box.appendChild(p); }
    p.textContent = text || '';
    p.className = 'kt-cm__msg' + (kind ? ' kt-cm__msg--' + kind : '');
  }

  function renderList() {
    rpc('kt_comments_list', { p_path: path }, false).then(function (rows) {
      elList.innerHTML = '';
      if (!rows || !rows.length) {
        var e = document.createElement('p');
        e.className = 'kt-cm__empty';
        e.textContent = 'まだコメントはありません。最初の1件をどうぞ。';
        elList.appendChild(e);
        if (elCount) elCount.textContent = '';
        return;
      }
      var shown = 0;
      rows.forEach(function (c) {
        if (c.status === 'approved') shown++;
        var li = document.createElement('li');
        li.className = 'kt-cm__item';
        var head = document.createElement('div');
        head.className = 'kt-cm__head';
        var name = document.createElement('span');
        name.className = 'kt-cm__name';
        name.textContent = c.display_name;
        var time = document.createElement('span');
        time.className = 'kt-cm__time';
        time.textContent = when(c.created_at);
        head.appendChild(name);
        head.appendChild(time);
        if (c.status !== 'approved') {
          var pend = document.createElement('span');
          pend.className = 'kt-cm__pending';
          pend.textContent = c.status === 'pending' ? '承認待ち' : '非公開';
          head.appendChild(pend);
        }
        var body = document.createElement('p');
        body.className = 'kt-cm__body';
        body.textContent = c.body;
        li.appendChild(head);
        li.appendChild(body);
        elList.appendChild(li);
      });
      if (elCount) elCount.textContent = shown > 0 ? shown + '件のコメント' : '';
    });
  }

  function renderLoggedOut() {
    elForm.className = 'kt-cm__box';
    elForm.innerHTML =
      '<p class="kt-cm__lead">コメントするには My FITPEAK へのログインが必要です。</p>' +
      '<p class="kt-cm__sub">My FITPEAK は無料の会員サービスです。すでに登録済みの方は、そのままログインできます。</p>' +
      '<div class="kt-cm__row kt-cm__row--login">' +
      '<input type="email" data-cm-email placeholder="メールアドレス" autocomplete="email" inputmode="email">' +
      '<input type="password" data-cm-pass placeholder="パスワード" autocomplete="current-password">' +
      '<button type="button" class="kt-cm__btn" data-cm-login>ログイン</button>' +
      '</div>' +
      '<p class="kt-cm__links"><a href="' + MYFP + '" target="_blank" rel="noopener">My FITPEAK に登録する（無料）</a>　／　<a href="' + MYFP + '" target="_blank" rel="noopener">パスワードを忘れた方</a></p>';

    var btn = elForm.querySelector('[data-cm-login]');
    btn.addEventListener('click', function () {
      var email = (elForm.querySelector('[data-cm-email]').value || '').trim();
      var pass = elForm.querySelector('[data-cm-pass]').value || '';
      if (!email || !pass) { msg(elForm, 'メールアドレスとパスワードを入力してください。', 'err'); return; }
      btn.disabled = true;
      msg(elForm, 'ログイン中…');
      authPost('token?grant_type=password', { email: email, password: pass }).then(function (r) {
        btn.disabled = false;
        if (r.ok && r.data && r.data.access_token) { saveSession(r.data); render(); renderList(); return; }
        var code = (r.data && (r.data.error_code || r.data.error)) || '';
        if (String(code).indexOf('email_not_confirmed') >= 0) {
          msg(elForm, 'メールアドレスの確認がまだ済んでいません。登録時のメールをご確認ください。', 'err');
        } else {
          msg(elForm, 'メールアドレスかパスワードが違います。', 'err');
        }
      }).catch(function () {
        btn.disabled = false;
        msg(elForm, '通信に失敗しました。時間をおいてお試しください。', 'err');
      });
    });
  }

  function renderLoggedIn() {
    var saved = ls(NKEY) || '';
    elForm.className = 'kt-cm__box';
    elForm.innerHTML =
      '<div class="kt-cm__who"><span data-cm-who></span>' +
      '<button type="button" class="kt-cm__btn kt-cm__btn--ghost" data-cm-logout>ログアウト</button></div>' +
      '<div class="kt-cm__row">' +
      '<input type="text" data-cm-name placeholder="表示名（24文字まで）" maxlength="24">' +
      '<textarea data-cm-body placeholder="この記事へのコメント（1000文字まで）" maxlength="1000"></textarea>' +
      '<div><button type="button" class="kt-cm__btn" data-cm-post>コメントを送る</button></div>' +
      '</div>' +
      '<p class="kt-cm__sub" style="margin:12px 0 0;">いただいたコメントは、編集部が確認したうえで公開します。</p>';

    elForm.querySelector('[data-cm-who]').textContent = 'ログイン中：' + (session.email || 'My FITPEAK 会員');
    elForm.querySelector('[data-cm-name]').value = saved;

    elForm.querySelector('[data-cm-logout]').addEventListener('click', function () {
      clearSession(); render(); renderList();
    });

    var post = elForm.querySelector('[data-cm-post]');
    post.addEventListener('click', function () {
      var name = (elForm.querySelector('[data-cm-name]').value || '').trim();
      var body = (elForm.querySelector('[data-cm-body]').value || '').trim();
      if (!body) { msg(elForm, 'コメントを入力してください。', 'err'); return; }
      post.disabled = true;
      msg(elForm, '送信中…');
      rpc('kt_comment_post', { p_path: path, p_name: name, p_body: body }, true).then(function (res) {
        post.disabled = false;
        if (res && res.ok) {
          ls2(NKEY, name);
          elForm.querySelector('[data-cm-body]').value = '';
          msg(elForm, '送信しました。確認のうえ公開します。', 'ok');
          renderList();
          return;
        }
        var err = (res && res.error) || '';
        if (err === 'rate_limited') msg(elForm, '短い間に投稿しすぎです。1時間あたり5件までです。', 'err');
        else if (err === 'login_required') { clearSession(); render(); msg(elForm, 'ログインの有効期限が切れました。もう一度ログインしてください。', 'err'); }
        else msg(elForm, '送信に失敗しました。時間をおいてお試しください。', 'err');
      }).catch(function () {
        post.disabled = false;
        msg(elForm, '送信に失敗しました。時間をおいてお試しください。', 'err');
      });
    });
  }

  function render() {
    if (session && session.refresh_token) renderLoggedIn(); else renderLoggedOut();
  }

  render();
  renderList();
})();
